import { render, staticRenderFns } from "./dataManageForm.vue?vue&type=template&id=3a9986e2&scoped=true"
import script from "./dataManageForm.vue?vue&type=script&lang=js"
export * from "./dataManageForm.vue?vue&type=script&lang=js"
import style0 from "./dataManageForm.vue?vue&type=style&index=0&id=3a9986e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9986e2",
  null
  
)

export default component.exports